import piexif from "piexifjs";

/**
 * Excerptus brand provenance values written into JPEG EXIF on download.
 * Brand-only — never includes user PII (no Author, no Copyright, no workspace name).
 */
export const EXCERPTUS_EXIF = {
  software: "Excerptus.io",
  description: "Created with Excerptus.io - https://excerptus.io",
} as const;

/**
 * Inject Excerptus brand provenance EXIF tags into a JPEG data URL.
 *
 * Writes two standard EXIF fields:
 *   - 0th.Software (0x0131)         → "Excerptus.io"
 *   - 0th.ImageDescription (0x010E) → "Created with Excerptus.io — https://excerptus.io"
 *
 * Returns the original dataURL unchanged if input is not a JPEG dataURL or
 * if EXIF write fails for any reason — downloads must never break.
 */
export function embedExcerptusMetadata(jpegDataUrl: string): string {
  if (typeof jpegDataUrl !== "string" || !jpegDataUrl.startsWith("data:image/jpeg")) {
    return jpegDataUrl;
  }
  try {
    const zeroth: Record<number, string> = {};
    zeroth[piexif.ImageIFD.Software] = EXCERPTUS_EXIF.software;
    zeroth[piexif.ImageIFD.ImageDescription] = EXCERPTUS_EXIF.description;
    const exifBytes = piexif.dump({ "0th": zeroth });
    return piexif.insert(exifBytes, jpegDataUrl);
  } catch {
    return jpegDataUrl;
  }
}
